import { render } from "./CommercialCalculatorSettingsPage.vue?vue&type=template&id=13c3d658&scoped=true"
import script from "./CommercialCalculatorSettingsPage.vue?vue&type=script&lang=js"
export * from "./CommercialCalculatorSettingsPage.vue?vue&type=script&lang=js"

import "./CommercialCalculatorSettingsPage.vue?vue&type=style&index=0&id=13c3d658&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13c3d658"]])

export default __exports__